import { AnalyticsService } from './analytics-service';

(function analyticsEvents() {
  if (document.getElementById('main-content')) {
    class AnalyticsEvent {
      public init() {
        const currentUrlOrigin = window.location.origin;
        const internalExternalUrls = [
          'https://mittkonto.vasttrafik.se',
          'https://foretagsportalen.vasttrafik.se',
          'https://skolportal.vasttrafik.se/',
          'https://partnerportalen.vasttrafik.se',
          'https://labs.vasttrafik.se',
          'https://paegnaben.se',
          'https://www.vasttrafik.se',
        ];
        // Bind click events to all links on page
        const links = document.querySelectorAll<HTMLAnchorElement>('.page a');
        for (let i = 0; i < links.length; i += 1) {
          // It's a pdf
          if (links[i].href.indexOf('.pdf') !== -1) {
            links[i].addEventListener('click', () => {
              AnalyticsService.addEvent(AnalyticsService.Links, 'Klick på PDF', links[i].href);
            });
          } else if (links[i].href.indexOf(currentUrlOrigin) === 0) {
            // Internal link
            links[i].addEventListener('click', () => {
              AnalyticsService.addEvent(AnalyticsService.Links, 'Klick på intern länk', links[i].href);
            });
          } else if (internalExternalUrls.some((x) => links[i].href.indexOf(x) === 0)) {
            // Internal external link
            links[i].addEventListener('click', () => {
              AnalyticsService.addEvent(AnalyticsService.Links, 'Klick på intern-extern länk', links[i].href);
            });
          } else if (links[i].href.indexOf('vasttrafik.se') === -1 || links[i].href.indexOf('paegnaben.se') === -1) {
            // External link
            links[i].addEventListener('click', () => {
              AnalyticsService.addEvent(AnalyticsService.Links, 'Klick på extern länk', links[i].href);
            });
          }
        }
      }
    }
    const page = new AnalyticsEvent();
    page.init();
  }
})();
